<template>
  <div class="comments-window" :class="{'minimized': minimized}">
    <div class="header" @click="minimized = !minimized">
      <b-icon icon="comment-multiple-outline" class="header-icon" size="is-small"></b-icon>
      <span>{{ $t('comments.title') }}</span>
      <button class="toggle"></button>
    </div>
    <div class="body">
      <div class="comments" ref="comments">
        <div class="comment" v-for="comment in comments">
          <img class="avatar" src="../assets/user.svg" alt="" v-if="!comment.author.thumb">
          <img class="avatar" :src="comment.author.thumb" alt="" v-else>
          <div>
            <div class="info">
              <span class="name">{{ comment.author.initials }}</span>
              <span class="dot"></span>
              <span class="time">{{ comment.created_at | localedDateTime }}</span>
            </div>
            <div class="text">
              {{ comment.text }}
            </div>
          </div>
        </div>
      </div>
      <textarea :placeholder="$t('comments.inputComment')" v-model="comment"></textarea>
    </div>
    <div class="controls">
      <div class="level">
        <div class="level-left" v-if="false">
          <a>
            <b-icon icon="at" size="is-small"></b-icon>
          </a>
          <a>
            <b-icon icon="file-plus-outline" size="is-small"></b-icon>
          </a>
        </div>
        <div class="level-right">
          <button class="send" @click="send">{{ $t('comments.send') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        minimized: true,
        comment: ''
      }
    },
    methods: {
      send() {
        this.$store.dispatch('Docflow/createComment', {
          text: this.comment,
          id: this.hierarchy.document.id
        }).then(() => {
          this.comment = ''
          this.$emit('update')
        })
      },
      refreshChat() {
        const comments = this.$refs.comments
        comments.scrollTop = comments.scrollHeight - comments.clientHeight;
      }
    },
    mounted() {
      this.refreshChat()
    },
    computed: {
      ...mapState('Docflow', ['hierarchy']),
      comments() {
        return this.hierarchy.comments.reverse()
      }
    },
    watch: {
      'hierarchy.comments'() {
        this.$nextTick(this.refreshChat)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .comments-window {
    width: 350px;
    position: fixed;
    bottom: 0;
    right: 35px;
    transition: bottom .2s ease;

    button.toggle {
      float: right;
      background: #fff;
      border: 0;
      height: 3px;
      border-radius: 5px;
      width: 15px;
      margin-top: 22px;
      cursor: pointer;
    }

    &.minimized {
      bottom: -375px;

      button.toggle {
        box-sizing: border-box;
        float: right;
        background: transparent;
        border: 2.5px solid #fff;
        border-top-width: 4px;
        border-radius: 2px;
        height: 12px;
        width: 12px;
        margin-top: 18px;
        cursor: pointer;
        transition: none;
      }
    }

    .header {
      background: #3498DB;
      color: #fff;
      height: 45px;
      line-height: 45px;
      padding: 0 22px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      cursor: pointer;

      .header-icon {
        font-size: 18px;
        margin-right: 10px;
      }

      span {
        font-weight: 600;
      }
    }

    .body {
      background: #fff;
      border-left: 1.5px solid #E6E8F1;

      .comments {
        height: 240px;
        overflow-y: scroll;
        padding: 16px 20px;

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #F5F5F5;
        }

        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
          background-color: #F5F5F5;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #c1c1c1;
        }

        .date {
          text-align: center;
          margin-bottom: 10px;
          color: #8E8E8E;
          position: relative;
          font-size: 13.5px;

          span {
            position: relative;
            display: inline-block;
            background: #fff;
            z-index: 1;
            padding: 0 16px;
            margin-bottom: 5px;
          }

          &:after {
            content: '';
            display: block;
            border-bottom: 1px solid #D3D3D3;
            position: absolute;
            top: 11px;
            left: 0;
            width: 100%;
          }
        }

        .comment {
          display: flex;
          align-items: flex-start;

          &:not(:last-child) {
            margin-bottom: 14px;
          }

          .avatar {
            width: 30px;
            height: 30px;
            border-radius: 15px;
            margin-right: 10px;
          }

          .info {
            margin-bottom: 3px;

            .name {
              font-weight: 600;
            }

            .dot {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #8E8E8E;
              border-radius: 4px;
              vertical-align: middle;
              margin: 0 6px 0 8px;
            }

            .time {
              font-size: 13px;
              color: #8E8E8E;
            }
          }

          .text {
            font-size: 13px;
          }
        }
      }

      textarea {
        width: 100%;
        height: 80px;
        border: 0;
        border-top: 2px solid #E6E8F1;
        border-right: 1.5px solid #E6E8F1;
        resize: none;
        padding: 12px 20px;
      }
    }

    .controls {
      background: #EBECF0;
      padding: 0 20px;

      .level-left,
      .level-right {
        height: 50px;
        line-height: 50px;
      }

      button.send {
        background: #3498DB;
        border-radius: 3px;
        border: 0;
        color: #fff;
        padding: 6px 12px;
        font-size: 13px;
        cursor: pointer;
      }

      a {
        font-size: 18px;
        margin-right: 8px;
      }
    }
  }
</style>
